import type { CSSProperties } from 'react';
import { useShell } from '@/hooks/useShell';

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}

export const DoctoralRail = () => {
  const { shell } = useShell();
  const items = (shell?.context_rail ?? []).slice(0, 5);

  return (
    <aside className="panel doctoral-rail" aria-label="Активные докторанты">
      <div className="panel-title">
        <span>Активные докторанты</span>
        <span className="badge doctoral-rail-badge">TOP-5</span>
      </div>
      <div className="doctoral-rail-list">
        {!items.length ? (
          <div className="owner-uat-empty" style={{ margin: 0 }}>
            Нет активных докторантов
          </div>
        ) : (
          items.map((item, index) => (
            <div key={item.id} className="doctoral-rail-row">
              <span className="doctoral-rail-av" aria-hidden="true">
                {initials(item.title)}
              </span>
              <span className="doctoral-rail-meta">
                <strong>{item.title}</strong>
                <small>{item.subtitle || `Рейтинг · #${index + 1}`}</small>
                <i
                  className="doctoral-rail-bar"
                  style={{ '--w': `${Math.min(100, 28 + item.counter / 2)}%` } as CSSProperties}
                />
              </span>
              <b>{item.counter}</b>
            </div>
          ))
        )}
      </div>
    </aside>
  );
};
